import EventEmitter from 'eventemitter2';

class EventSet extends EventEmitter{
	constructor(iterable = null){
		super();
		this._set = new Set(iterable);
	}

	get size(){
		return this._set.size;
	}

	add(value){
		this._set.add(value);
		this.emit('add', value);
	}

	has(value){
		return this._set.has(value);
	}

	delete(value){
		let deleted = this._set.delete(value);
		this.emit('delete', value);
		return deleted;
	}

	entries(){
		return this._set.entries();
	}

	values(){
		return this._set.values();
	}

	keys(){
		return this._set.keys();
	}

	clear(){
		if(this.listenedCount('delete') > 0)
			this._set.forEach(value => this.emit('delete', value));
		this.emit('clear');
		this._set.clear();
	}


	[Symbol.iterator]() {
		return this._set[Symbol.iterator]();
	};
}

export default EventSet;
export { EventSet };